import React, { Component } from 'react';
import { Link, useParams } from 'react-router-dom';
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import { Form, InputGroup, Col, Row, } from 'react-bootstrap';
import paginationFactory from 'react-bootstrap-table2-paginator';
import MediaQuery from 'react-responsive';
import DBService from '../../service/DBService';
import ATSShowDetails from './ATSShowDetails';
import '../../css/ATSListDisplay.css';

let searchInputValue = '';

const options = {
    sizePerPage: 20,
    hideSizePerPage: true,
};

const MySearch = (props) => {
    let input;
    const handleClick = () => {
        props.onSearch(input.value);
        searchInputValue = input.value;
    };
    return (
        <div>
            <InputGroup size="sm" className="mb-3">
                <Form.Control size="sm" type="text" placeholder="Search" value={searchInputValue} onChange={handleClick} ref={n => input = n} />
            </InputGroup>
        </div>
    );
};

const mobileColumns = [
    {
        dataField: "issueSymbolIdentifier",
        text: "Ticker",
        sort: true,
        formatter: (cell, row) => <Link to={'/chart/' + cell}>{cell}</Link>,
        headerStyle: { fontSize: '10px' },
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'left'
            }
        }
    },
    {
        dataField: "totalWeeklyShareQuantity",
        text: "Weekly Total Shares",
        sort: true,
        headerStyle: { fontSize: '10px' },
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'right'
            }
        }
    },
    {
        dataField: "totalWeeklyTradeCount",
        text: "Weekly Total Trades",
        sort: true,
        headerStyle: { fontSize: '10px' }
    },
    {
        dataField: "lastUpdateDate",
        text: "Week",
        sort: true,
        headerStyle: { fontSize: '10px' },
        hidden: false
    },
    {
        dataField: "",
        text: "Details",
        sort: false,
        formatter: (cell, row) => <i className={'fa fa-file-text'} style={{ height: '10px', width: '10px', cursor: 'pointer' }}></i>,
        headerStyle: { fontSize: '10px', width: '50px' },
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'center'
            }
        },
    },
];


const columns = [
    {
        dataField: "issueSymbolIdentifier",
        text: "Ticker",
        sort: true,
        formatter: (cell, row) => <Link to={'/chart/' + cell}>{cell}</Link>,
        headerStyle: { fontSize: '10px' },
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'left'
            }
        }
    },
    {
        dataField: "issueName",
        text: "Description",
        sort: true,
        headerStyle: { fontSize: '10px' },
        hidden: false,
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'left'
            }
        }
    },
    {
        dataField: "totalWeeklyShareQuantity",
        text: "Weekly Total Shares",
        sort: true,
        headerStyle: { fontSize: '10px' },
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'right'
            }
        }
    },
    {
        dataField: "totalWeeklyTradeCount",
        text: "Weekly Total Trades",
        sort: true,
        headerStyle: { fontSize: '10px' }
    },
    {
        dataField: "lastUpdateDate",
        text: "Week",
        sort: true,
        headerStyle: { fontSize: '10px' },
        hidden: false
    },
    {
        dataField: "",
        text: "Details",
        sort: false,
        formatter: (cell, row) => <i className={'fa fa-file-text'} style={{ height: '10px', width: '10px', cursor: 'pointer' }}></i>,
        headerStyle: { fontSize: '10px', width: '80px' },
        style: (cell, row, rowIndex, colIndex) => {
            return {
                textAlign: 'center',
            }
        },
    },

];

const expandRow = {
    onlyOneExpanding: true,
    parentClassName: 'my-parent-expand-foo',
    showExpandColumn: true,
    renderer: row => (
        <ATSShowDetails week={row.lastUpdateDate} symbol={row.issueSymbolIdentifier} />
    )
};

const rowStyle = (row, rowIndex) => {
    const style = {};
    style.fontSize = '10px';
    style.textAlign = 'right';
    return style;
};

class ATSSelectedStockListDisplayWithProps extends Component {
    constructor(props) {
        super(props);
        this.state = {
            symbol: this.props.symbol,
            atsWeeklyList: [],
            reload: false,
            columns: columns,
            mobileColumns: mobileColumns,
            searchInputValue: '',
        };
        console.log('ATSListDisplay props', this.props, this.state.symbol);
    }

    componentDidMount() {
        this.getData();
    }

    getData() {
        DBService.getAtsAllWeeklyTotalForSelectedStock(this.state.symbol)
        .then(result => {
            console.log('ats getAtsAllWeeklyTotalForSelectedStock', result);
            if (result !== undefined && result.data !== undefined && result.data.length > 0) {
                result = result.data;
                this.setState({ atsWeeklyList: result, reload: true });
            }
        })
        .catch((error) => {
            console.log(error);
        });
   }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    selectUpdateObj(selectedOptions) {
        let tmpObj = {
            selectedKey: [
                JSON.parse(selectedOptions.target.value)
            ],
            selectedValue: []
        }
        return tmpObj;
    }


    render() {
        return (
            <>
                &nbsp;&nbsp;&nbsp;&nbsp;Alternative Trading System (ATS) Screener - {this.state.symbol}
                <MediaQuery minWidth={501}>
                    <ToolkitProvider
                        keyField="lastUpdateDate"
                        data={this.state.atsWeeklyList}
                        columns={this.state.columns}
                        search={{ defaultSearch: searchInputValue }}
                    >
                        {
                            props => (
                                <>  <Row>
                                    <Col>
                                        <MySearch {...props.searchProps} />
                                    </Col>
                                </Row>
                                    {/* <hr /> */}
                                    <BootstrapTable
                                        {...props.baseProps}
                                        // hover
                                        bootstrap4
                                        rowStyle={rowStyle}
                                        expandRow={expandRow}
                                        pagination={paginationFactory(options)}
                                    />
                                </>
                            )
                        }
                    </ToolkitProvider>
                </MediaQuery>

                <MediaQuery maxWidth={500}>
                    <ToolkitProvider
                        keyField="lastUpdateDate"
                        data={this.state.atsWeeklyList}
                        columns={this.state.mobileColumns}
                        search={{ defaultSearch: searchInputValue }}
                    >
                        {
                            props => (
                                <>
                                    <Row>
                                        <Col>
                                            <MySearch {...props.searchProps} />
                                        </Col>
                                    </Row>
                                    {/* <hr /> */}
                                    <BootstrapTable
                                        {...props.baseProps}
                                        // hover
                                        bootstrap4
                                        rowStyle={rowStyle}
                                        expandRow={expandRow}
                                        pagination={paginationFactory(options)}
                                    />
                                </>
                            )
                        }
                    </ToolkitProvider>
                </MediaQuery>
            </>
        );
    }
}

function ATSSelectedStockListDisplay(props) {
  let params = useParams();
  console.log('ATSSelectedStockListDisplay props', params);
  return <ATSSelectedStockListDisplayWithProps {...props} symbol={params.symbol} />
}

export default ATSSelectedStockListDisplay;
